import { EMfaActionType, MfaAction, MfaState } from '../LoginModal.types';

export const initialMfaState: MfaState = {
  session: {
    email: '',
    password: '',
    rememberMe: true,
    mfaSessionToken: null
  },
  attempts: {
    maxAttempts: 5,
    currentAttempt: 0
  },
  lockout: {
    endTime: null,
    type: null
  },
  cooldownEndsAtMs: null
};

const mfaActionHandlers: Record<EMfaActionType, (state: MfaState, action: MfaAction) => MfaState> = {
  [EMfaActionType.SET_SESSION]: (state, action) => {
    if (action.type !== EMfaActionType.SET_SESSION) return state;
    return {
      ...state,
      session: {
        email: action.payload.email,
        password: action.payload.password,
        rememberMe: action.payload.rememberMe,
        mfaSessionToken: action.payload.mfaSessionToken
      },
      attempts: {
        maxAttempts: action.payload.maxAttempts,
        currentAttempt: action.payload.currentAttempt
      },
      lockout: {
        endTime: null,
        type: null
      },
      cooldownEndsAtMs: action.payload.cooldownEndsAtMs
    };
  },
  [EMfaActionType.SET_LOCKOUT]: (state, action) => {
    if (action.type !== EMfaActionType.SET_LOCKOUT) return state;
    return {
      ...state,
      lockout: {
        endTime: action.payload.endTime,
        type: action.payload.type
      }
    };
  },
  [EMfaActionType.CLEAR_LOCKOUT]: (state) => ({
    ...state,
    lockout: {
      endTime: null,
      type: null
    },
    attempts: {
      ...state.attempts,
      currentAttempt: 0
    }
  }),
  [EMfaActionType.UPDATE_ATTEMPTS]: (state, action) => {
    if (action.type !== EMfaActionType.UPDATE_ATTEMPTS) return state;
    return {
      ...state,
      attempts: {
        maxAttempts: action.payload.max,
        currentAttempt: action.payload.current
      }
    };
  },
  [EMfaActionType.RESET_ATTEMPTS]: (state) => ({
    ...state,
    attempts: {
      ...state.attempts,
      currentAttempt: 0
    }
  }),
  [EMfaActionType.RESEND_SUCCEEDED]: (state, action) => {
    if (action.type !== EMfaActionType.RESEND_SUCCEEDED) return state;
    return {
      ...state,
      session: {
        ...state.session,
        mfaSessionToken: action.payload.mfaSessionToken
      },
      cooldownEndsAtMs: action.payload.cooldownEndsAtMs
    };
  }
};

export const mfaReducer = (state: MfaState, action: MfaAction): MfaState => {
  const handler = mfaActionHandlers[action.type];
  return handler ? handler(state, action) : state;
};
